import InputFile from '../../Atoms/InputFile';
import InputFileExt from '../../Atoms/InputFileExt';
import InputText from '../../Atoms/InputText';
import Title from '../../Atoms/Title';

function Forms() {
  return (
    <div className="mx-auto max-w-7xl py-24 px-3">
      <div className="max-w-xl">
        <form
          action="#!"
          className="grid grid-cols-1 gap-12"
        >
          <div className="grid grid-cols-1 gap-5">
            <Title as="h3">InputText</Title>
            <InputText label="Input" />
            <InputText
              label="Input"
              status="error"
              errorMsg="I'm an error message"
            />
            <InputText
              label="Input"
              status="success"
              errorMsg="I'm an error message"
            />
          </div>
          <div className="grid grid-cols-1 gap-5">
            <Title as="h3">InputFile</Title>
            <InputFile placeholder="File" />
            <InputFile
              placeholder="File"
              status="error"
              errorMsg="Error message"
            />
            <InputFile
              placeholder="File"
              status="success"
            />
          </div>
          <div className="grid grid-cols-1 gap-5">
            <Title as="h3">InputFileExt</Title>
            <InputFileExt />
            <InputFileExt
              status="error"
              errorMsg="Error message here"
            />
            <InputFileExt status="success" />
          </div>
        </form>
      </div>
    </div>
  );
}

export default Forms;
